export function currentLightStompunkt(state) {
	if (state.currentStompunkt == null) {
		return null
	}
	const result = state.lightStompunkter[state.currentStompunkt]
	if (result == null) {
		throw new Error("Current stompunkt is not cached in lightStompunkter.")
	}
	else {
		return result
	}
}

export function currentLightStompunktIfCached(state) {
	if (state.currentStompunkt == null) {
		return null
	}
	return state.lightStompunkter[state.currentStompunkt]
}

export function currentHeavyStompunkt(state) {
	if (state.currentStompunkt == null) {
		return null
	}
	const result = state.heavyStompunkter[state.srid][state.currentStompunkt]
	if (result == null) {
		throw new Error("Current stompunkt is not cached in heavyStompunkter.")
	}
	else {
		return result
	}
}

export function currentStompunktIsSelected(state) {
	return state.selectedStompunkter.includes(state.currentStompunkt)
}



// WEBPACK FOOTER //
// ./src/selectors/currentStompunkt.js